import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { message, Spin } from "antd";

import * as actions from "../../actions";
import Form from "./Form";
import { PageTitle, ReportBtn } from "lib/widget";

import * as moment from "moment";

const initialState = {
  branchId: [],
  fileType: "excel",
  startDate: null,
  endDate: null,
  pickStartDate: null,
  pickEndDate: null
};

class DailyReport extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.onKeyValueChange = this.onKeyValueChange.bind(this);
  }

  onKeyValueChange(name, value) {
    this.setState((state, props) => {
      return { ...state, [name]: value };
    });
  }

  onDateChange = (value) => {
    this.setState({ ...this.state, ...value })
  }

  clearFilter = () => {
    this.setState(initialState);
  };

  downloadDaily = () => {
    const {
      startDate,
      endDate,
      branchId,
      pickStartDate,
      pickEndDate,
      fileType
    } = this.state;
    if (!startDate || !endDate) return message.error("Please select date");
    if (branchId.length === 0) return message.error("Please select branch");

    let start = moment(pickStartDate + " 00:00:00")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss")
    ;
    let end = moment(pickEndDate + " 23:59:59")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss")


    this.props.downloadDaily(
      branchId,
      start,
      end,
      pickStartDate,
      pickEndDate,
      fileType
    );
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.errorMessage !== prevState.errorMessage) {
      return { errorMessage: nextProps.errorMessage };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.errorMessage !== this.props.errorMessage) {
      message.error(this.props.errorMessage);
    }
  }

  componentDidMount() {
    this.props.loadReportBranch();
  }

  render() {
    return (
      <Fragment>
        <PageTitle name="report_daily" component={null} />
        <Spin size="large" spinning={this.props.loading}>
          <Form
            {...this.state}
            branches={this.props.branches}
            onDateChange={this.onDateChange}
            onKeyValueChange={this.onKeyValueChange}
          />
          <ReportBtn onDowload={this.downloadDaily} onClear={this.clearFilter} />
        </Spin>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ reports }) => ({
  branches: reports.branches,
  loading: reports.daily_loading,
  errorMessage: reports.errorMessage
});

const mapDispatchToProps = {
  downloadDaily: actions.downloadDaily.request,
  loadReportBranch: actions.loadReportBranch.request
};

export default connect(mapStateToProps, mapDispatchToProps)(DailyReport);
